import "../../styles/layout.scss";
import { Chat } from "../Chat";
import { NotificationsList } from "../NotificationsList";
import { useRef, useState, useEffect } from "react";
import { useUnit } from "effector-react";
import { $pushNotifications } from "../../store/pushNotifications";
import { $chatMessages, $isAuth, $userData, setIsAuth } from "../../store";
import { FloatingTabsPanel } from "../FloatingTabsPanel";
import { $unreadAnnouncementsCount } from "../../store";
import Icon, { CreditCardFilled, HomeFilled, LogoutOutlined, MessageFilled, ReadFilled, StarFilled } from "@ant-design/icons";
import { ReactComponent as hammer } from "../../assets/hammer.svg";
import { ReactComponent as hammerFinish } from "../../assets/hammerFinish.svg";
import { ReactComponent as box } from "../../assets/box.svg";
import { ReactComponent as logoIcon } from "../../assets/logo-mini.svg";
import { ReactComponent as logoText } from "../../assets/logo-text.svg";
import { Badge, ConfigProvider, Menu } from "antd";
import Sider from "antd/es/layout/Sider";
import Cookies from "universal-cookie";

export const Side = ({ collapsed }) => {
    const [unreadMessages, setUnreadMessages] = useState({
        messages: 0,
        notifications: 0
    });
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const buttonRef = useRef(null);

    const messages = useUnit($chatMessages);
    const userData = useUnit($userData);
    const isAuth = useUnit($isAuth);
    const pushNotifications = useUnit($pushNotifications);
    const unreadAnnouncementsCount = useUnit($unreadAnnouncementsCount);

    const pathname = window.location.pathname.split('/').pop();

    useEffect(() => {
        const unreadMessages = messages.filter(message => !message.read && message.senderId !== userData.id && message.recipientId === userData.id).length;
        const unreadNotifications = pushNotifications.filter(notification => !notification.isRead).length;
        setUnreadMessages({
            messages: unreadMessages,
            notifications: unreadNotifications
        });
    }, [messages, pushNotifications, userData]);

    const goToMain = () => {
        window.location.href = '/';
    };

    const openPanel = () => {
        if (!isAuth) {
            window.location.href = `/authorization?returnUrl=${window.location.pathname}`;
            return;
        }

        setIsPanelOpen(true);
    };

    const goToCurrentBiddings = () => {
        window.location.href = "/currentBiddings";
    };

    const goToSubscriptionPay = () => {
        if (!isAuth) {
            window.location.href = `/authorization?returnUrl=/payment`;
            return;
        }
        window.location.href = `/payment`;
    }

    const goToFavoriteBiddings = () => {
        if (!isAuth) {
            window.location.href = `/authorization?returnUrl=/favoriteBiddings`;
            return;
        }
        window.location.href = `/favoriteBiddings`;
    }

    const goToCompletedBiddings = () => {
        window.location.href = `/completedBiddings`;
    }

    const goToOrders = () => {
    }

    const goToRules = () => {
        window.location.href = `/rules`;
    }

    const logout = () => {
        setIsAuth(false);
        const cookies = new Cookies();
        cookies.remove("token");
        window.location.href = "/";
    }

    const menuItems = [
        {key: '', icon:
                <Badge count={unreadAnnouncementsCount} size="small" offset={[0, collapsed ? 10 : 0]} color={'#CF1322'}>
                    <HomeFilled />
                </Badge>, label: 'Главная'
        },
        { key: 'chat', icon: (
                <Badge count={unreadMessages.messages + unreadMessages.notifications} size="small" offset={[0, collapsed ? 10 : 0]} color={'#CF1322'}>
                    <MessageFilled />
                </Badge>), label: 'Чат'
        },
        { key: 'currentBiddings', icon: <Icon component={hammer} />, label: 'Торги' },
        { key: 'payment', icon: <CreditCardFilled />, label: 'Оплата' },
        { key: 'favoriteBiddings', icon: <StarFilled />, label: 'Избранные лоты' },
        { key: 'completedBiddings', icon: <Icon component={hammerFinish} />, label: 'Завершенные торги' },
        { key: 'orders', icon: <Icon component={box} />, label: 'Заказы' },
        { key: 'rules', icon: <ReadFilled />, label: 'Правила' },

    ];

    const handleMenuClick = (info) => {
        switch (info.key) {
            case '':
                goToMain();
                break;
            case 'chat':
                openPanel();
                break;
            case 'currentBiddings':
                goToCurrentBiddings();
                break;
            case 'payment':
                goToSubscriptionPay();
                break;
            case 'favoriteBiddings':
                goToFavoriteBiddings();
                break;
            case 'completedBiddings':
                goToCompletedBiddings();
                break;
            case 'orders':
                goToOrders();
                break;
            case 'rules':
                goToRules();
                break;
            case 'logout':
                logout();
                break;
        }
    };

    return (

        <div className="layout__side">
            <Sider
                trigger={null}
                collapsible collapsed={collapsed}
                className="layout__side__sider"
                width={206}
                collapsedWidth={80}
            >
                <div className={"layout__side__logo"}>
                    <Icon className={"layout__side__logo__icon"} component={logoIcon} />
                    {!collapsed && <Icon className={"layout__side__logo__text"} component={logoText} />}
                </div>
                <ConfigProvider
                    theme={{
                        components: {
                            Menu: {
                                itemColor: '#727272',
                                itemIconColor: '#727272',
                                itemSelectedColor: '#722ED1',
                                itemSelectedBg: '#F5EFFF',
                                itemActiveBg: '#F5EFFF',
                                fontSize: 14,
                                iconFontSize: 16
                            },
                        },
                    }}
                >
                    <Menu className="layout__side__menu"
                        theme="light"
                        mode="inline"
                        inlineCollapsed={collapsed}
                        items={menuItems}
                        onClick={handleMenuClick}
                        defaultSelectedKeys={[pathname]}
                    />
                </ConfigProvider>
                <ConfigProvider
                    theme={{
                        components: {
                            Menu: {
                                itemColor: '#CF1322',
                                itemIconColor: '#CF1322',
                                itemSelectedColor: '#CF1322',
                                itemSelectedBg: '#F5EFFF',
                                itemActiveBg: '#F5EFFF',
                                fontSize: 14,
                                iconFontSize: 16
                            },
                        },
                    }}
                >
                    <Menu
                        className="layout__side__menu__logout"
                        theme="light"
                        mode="inline"
                        selectable={false}
                        onClick={handleMenuClick}
                        items={[
                            { key: 'logout', icon: <LogoutOutlined style={{ fontSize: 16 }} />, label: 'Выход' },
                        ]}
                    />
                </ConfigProvider>
                <FloatingTabsPanel
                    isOpen={isPanelOpen}
                    onClose={() => setIsPanelOpen(false)}
                    anchorEl={buttonRef.current}
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                    tabs={[
                        {
                            id: 'chat',
                            label: 'Чат',
                            icon: '💬',
                            component: Chat,
                            unreadCount: unreadMessages.messages
                        },
                        {
                            id: 'notifications',
                            label: 'Уведомления',
                            icon: '🔔',
                            component: NotificationsList,
                            unreadCount: unreadMessages.notifications
                        }
                    ]}
                    collapsed={collapsed}
                />
            </Sider>
        </div>
    )
}